<style lang="postcss">
	.navigation-container {
		display: flex;
		position: relative;
	}

	aside {
		position: sticky;
		top: 6rem;
		height: 90vh;
		height: calc(100vh - 8.5rem);
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
		align-items: stretch;
		overflow: hidden;
	}

	nav {
		width: 100%;
		display: flex;
		flex-direction: column;
		flex: 1 1 auto;
		overflow-y: auto;
		overscroll-behavior: contain;
	}

	.content-wrapper {
		display: flex;
		flex-flow: column;
		flex: 1 1 auto;
		min-width: 0;
	}

	ul {
		list-style-type: none;
		padding: 0;
		display: flex;
		flex-direction: column;
		list-style: none;
	}

	ul.parent {
		width: 100%;
		font-size: 0.95rem;
	}

	.item-icon {
		width: 1.5rem;
		min-width: 1.5rem;
		padding-right: 0.5rem;
		display: inline-flex;
	}

	.item-icon :global(svg) {
		width: 100%;
	}

	.item-text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	ul.ul-children {
		margin-top: 0.2rem;
		margin-bottom: 0.3rem;
		margin-left: 0.2rem;
		padding: 0;
		font-size: 0.9rem;
		position: relative;
		display: none;
		overflow-y: auto;
	}
	ul.has-icon.ul-children {
		margin-left: 0.525rem;
	}
	ul.ul-visible {
		display: block;
	}
	ul.ul-children::before {
		border-radius: 2px;
		width: 2px;
		content: "";
		position: absolute;
		top: 3px;
		bottom: 3px;
		left: 2px;
		background-color: rgba(0, 0, 0, 0.075);
	}

	li {
		margin: 0;
		padding: 0;
		display: flex;
		flex-flow: column;
		width: 100%;
	}

	li a {
		padding: 0.175rem 0.5rem 0.175rem 0.25rem;
		font-weight: 420;
		display: flex;
		flex-flow: row nowrap;
		width: 100%;
		min-width: 0;
	}

	li .li-content {
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: stretch;
	}

	.chevron-button {
		opacity: 0.5;
		display: block;
		width: 1.75rem;
		padding-left: 0.5rem;
	}

	.chevron-button span {
		display: block;
		height: 14px;
		width: 100%;
	}

	.active.chevron-button,
	.chevron-button:hover {
		opacity: 1;
	}

	ul.ul-children li {
		padding: 0;
		position: relative;
	}
	ul.ul-children li a {
		padding: 0.125rem 2rem 0.125rem 0.8rem;
	}
	ul.has-icon.ul-children li a {
		padding-left: 1.25rem;
	}
	ul.ul-children li.active::before {
		border-radius: 10px;
		width: 2px;
		content: "";
		position: absolute;
		top: 3px;
		bottom: 3px;
		left: 2px;
		@apply bg-theme-600;
	}

	a {
		text-decoration: none;
		color: inherit;
	}

	a.active,
	a:hover {
		@apply text-theme-600;
		-webkit-text-stroke: 0.25px;
	}

	li .li-content a {
		display: flex;
		flex: 1 1 auto;
	}

	.breadcrumb-cover {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-self: start;
	}

	.mobile-nav-toggle {
		display: none;
	}

	@media (max-width: 768px) {
		ul.parent {
			font-size: 14.5px;
			font-weight: 420;
		}
		ul.ul-children {
			font-size: 13.5px;
		}
		.breadcrumb-cover {
			margin: 0;
			font-size: 13.5px;
			bottom: auto;
			height: 2.5rem;
			width: 100%;
			width: calc(100% - 3.5rem);
			z-index: 41;
			position: sticky;
			top: 0.5rem;
			padding-left: 0;
			font-weight: 440;
		}
		.breadcrumb-white-background {
			background-color: white;
			border-bottom: 1px solid #e5e7eb;
			position: absolute;
			height: 2.5rem;
			width: 100%;
			z-index: 39;
			top: 1px;
		}
		.breadcrumb-sticky {
			background-color: white;
			display: flex;
			flex: 1 0 0;
			min-width: 0;
			flex-flow: row nowrap;
			height: 100%;
			width: auto;
		}
		main {
			padding-top: 1.5rem;
		}
		.navigation-container {
			flex-direction: column;
		}
		.mobile-nav-toggle {
			gap: 0.25rem;
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			justify-content: space-between;
			padding: 0.5rem 0.15rem 0.5rem 0;
		}

		.mobile-nav-toggle > svg {
			top: -1px;
			position: relative;
		}

		aside {
			position: fixed;
			top: 0;
			left: 0;
			bottom: 0;
			height: 100vh;
			height: 100dvh;
			width: 75vw !important;
			padding: 1.25rem;
			overflow-y: hidden;
			overscroll-behavior: contain;
			z-index: 44;
			background-color: white;
		}
		.backdrop {
			position: fixed;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			background-color: rgba(0, 0, 0, 0.5);
			z-index: 43;
			overscroll-behavior: contain;
		}

		aside.mobile-open {
			transform: translateX(0);
		}

		aside:not(.mobile-open) {
			display: none;
		}
	}

	@media (min-width: 768px) {
		.desktop-hide aside {
			display: none;
		}
		.breadcrumb-cover {
			font-size: 14.5px;
			margin-bottom: 1rem;
		}
		.navigation-container:not(.desktop-hide) .content-wrapper {
			margin-left: 3rem;
		}
	}
</style>

<script lang="ts">
	import * as icons from "$lib/Components/Icons/";
	import Breadcrumbs from "$src/lib/Components/Basic/Breadcrumbs.svelte";
	import { page } from "$app/stores";
	import { slide } from "svelte/transition";

	export let items: NavItem[];
	export let label = "Help";
	export let path = "/";
	export let site_base = "/";
	export let highlight: null | string = null;
	export let hideNavOnDesktop = false;
	export let width = 240;
	export let addItem: {
		name: string;
		id: string;
	} | null = null;

	let isNavOpen = false;
	let currentPath = "";
	let crumbs: Breadcrumb[] = [];
	let navElement: HTMLElement;
	let asideElement: HTMLElement;
	let toggledNav: string | null = null;
	let jsonLd: any = {};
	let current_active_child: {
		crumb?: string;
		label: string;
		path: string;
	} | null = null;
	let current_parent: NavItem | null = null;

	$: {
		currentPath = $page.url.pathname;
	}

	function toggleNav() {
		isNavOpen = !isNavOpen;
		adjustBodyScroll(isNavOpen);
	}

	function adjustBodyScroll(isNavOpen: boolean) {
		if (isNavOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}
	}

	function isActiveParent(item: NavItem) {
		if (current_parent === null && item.path === "") return true;
		if (item.path === "") return false;
		if (!current_parent) return false;
		return current_parent.path === item.path;
	}

	function isActiveChild(child: any) {
		if (!current_active_child) return false;
		return current_active_child.path === child.path;
	}

	function getBreadcrumbs(items: NavItem[], currentPath: string) {
		const checkPath = highlight ? `${path}/${highlight}` : currentPath;
		crumbs = [
			{
				text: label,
				link: path,
				hideOnMobile: true
			}
		];
		const jsonLdItems: any[] = [
			{
				"@type": "ListItem",
				position: 1,
				name: label,
				item: `${site_base}${path}`
			}
		];
		current_active_child = null;
		current_parent = null;

		for (const item of items) {
			if (item.children) {
				const child = item.children.find((child) =>
					checkPath.startsWith(`${path}/${child.path}`)
				);
				if (child) {
					current_active_child = child;
					current_parent = item;
				}
			}
		}
		if (!current_parent) {
			current_parent =
				items.find(
					(item) =>
						item.path !== "" && checkPath.startsWith(`${path}/${item.path}`)
				) ?? null;
		}
		if (current_parent) {
			crumbs.push({
				text: current_parent.crumb ?? current_parent.label,
				link: `${path}/${current_parent.path}`
			});
			jsonLdItems.push({
				"@type": "ListItem",
				position: jsonLdItems.length + 1,
				name: current_parent.crumb ?? current_parent.label,
				item: `${site_base}${path}/${current_parent.path}`
			});
		}
		if (current_active_child) {
			crumbs.push({
				text: current_active_child.crumb ?? current_active_child.label,
				link: `${path}/${current_active_child.path}`
			});
			jsonLdItems.push({
				"@type": "ListItem",
				position: jsonLdItems.length + 1,
				name: current_active_child.crumb ?? current_active_child.label,
				item: `${site_base}${path}/${current_active_child.path}`
			});
		}
		if (addItem) {
			crumbs.push({
				text: addItem.name,
				link: `${path}/${addItem.id}`,
				hidden: true
			});
			jsonLdItems.push({
				"@type": "ListItem",
				position: jsonLdItems.length + 1,
				name: addItem.name,
				item: `${site_base}${path}/${addItem.id}`
			});
		}
		jsonLd = {
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
			itemListElement: jsonLdItems
		};
	}

	$: getBreadcrumbs(items, currentPath);

	function clickEvent(event: MouseEvent) {
		if (
			isNavOpen &&
			asideElement &&
			asideElement !== event.target &&
			!asideElement.contains(event.target as Node)
		) {
			isNavOpen = false;
			adjustBodyScroll(isNavOpen);
		}
	}

	function createPath(item1: string, item2: string) {
		if (item2) {
			return `${item1}/${item2}`;
		} else {
			return item1;
		}
	}

	$: updateToggleNav(items);

	function updateToggleNav(items: NavItem[]) {
		for (const item of items) {
			if (item.children) {
				if (isActiveParent(item)) {
					toggledNav = item.path;
				}
			}
		}
	}
</script>

<svelte:head>
	{@html `<script type="application/ld+json">` +
		JSON.stringify(jsonLd) +
		`</script>`}
</svelte:head>

<svelte:body on:click="{clickEvent}" />

<div
	class:desktop-hide="{hideNavOnDesktop}"
	class="navigation-container {$$props.class ?? ''}">
	{#if isNavOpen}
		<div class="backdrop"></div>
	{/if}

	<aside
		bind:this="{asideElement}"
		style="width: {width}px; min-width: {width}px"
		class:mobile-open="{isNavOpen}">
		<slot name="search" />
		<nav id="sidebar-nav" bind:this="{navElement}">
			<ul class="parent">
				{#each items as item}
					<li class:active="{isActiveParent(item)}">
						<div class="li-content">
							<a
								href="{createPath(path, item.path)}"
								class:active="{isActiveParent(item)}">
								{#if item.icon}
									<img
										alt="{item.label} illustration"
										loading="lazy"
										width="24"
										height="24"
										class="item-icon"
										src="{item.icon}" />
								{/if}
								<span class="item-text">
									{item.label}
								</span>
							</a>
							{#if item.children}
								<button
									on:click|stopPropagation="{() => {
										if (toggledNav === item.path) {
											toggledNav = null;
										} else {
											toggledNav = item.path;
										}
									}}"
									aria-label="Toggle section"
									type="button"
									class:active="{item.path === toggledNav}"
									class="chevron-button">
									<span>
										{#if item.path !== toggledNav}
											{@html icons.ChevronDown}
										{:else}
											{@html icons.ChevronUp}
										{/if}
									</span>
								</button>
							{/if}
						</div>
						{#if item.children}
							<ul
								transition:slide="{{ duration: 200 }}"
								class:has-icon="{item.icon}"
								class:ul-visible="{item.path === toggledNav}"
								class="ul-children">
								{#each item.children as child}
									<li class:active="{isActiveChild(child)}">
										<div class="li-content">
											<a
												href="{createPath(path, child.path)}"
												class:active="{isActiveChild(child)}">
												<span class="item-text">
													{child.label}
												</span>
											</a>
										</div>
									</li>
								{/each}
							</ul>
						{/if}
					</li>
				{/each}
			</ul>
		</nav>
	</aside>

	<div class="content-wrapper">
		<div class="breadcrumb-white-background"></div>
		<div class="breadcrumb-cover">
			<nav class="breadcrumb-sticky pl-base md:pl-0">
				<button
					aria-label="Expand sidebar"
					aria-expanded="{isNavOpen}"
					type="button"
					aria-controls="sidebar-nav"
					class="mobile-nav-toggle"
					on:click|stopPropagation="{toggleNav}">
					<svg
						width="16"
						height="16"
						viewBox="0 0 18 18"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M3 4H15"
							stroke="currentColor"
							stroke-width="1.75"
							stroke-linecap="round"></path>
						<path
							d="M3 9H15"
							stroke="currentColor"
							stroke-width="1.75"
							stroke-linecap="round"></path>
						<path
							d="M3 14H9"
							stroke="currentColor"
							stroke-width="1.75"
							stroke-linecap="round"></path>
					</svg>
					<span>
						{label}
					</span>
				</button>
				<Breadcrumbs
					itemClass="py-2 md:py-1"
					seamless="{true}"
					data="{crumbs}" />
			</nav>
		</div>
		<main class="px-base md:px-0">
			<slot></slot>
		</main>
	</div>
</div>
